import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export default interface DocumentValidationData {
  isVerified: boolean;
  originHash: string;
  targetHash: string;
  verifiedAt: number;
}

interface VerifyTargetFileParam {
  fileId: string;
  otp: string;
  documentId: string;
}

export async function verifyTargetFile({ fileId, otp, documentId }: VerifyTargetFileParam) {
  return requestApi<DocumentValidationData>({
    url: withDocument(`/documents/${documentId}/file-hashes/verify`),
    method: 'POST',
    data: {
      fileId,
      otp,
    },
  }).then((response) => response.data);
}
